<template>
  <div class="popup-root">
    <div class="popup-mask">
      <div class="popup">
        <div class="popup-close" @click="close">
          <img src="~@/assets/images/close.svg" />
        </div>
        <div class="popup-title">{{ title }}</div>
        <div class="popup-content">{{ content }}</div>
        <!-- <div class="popup-close-mobile" @click="close">
          <img src="~@/assets/images/close-white.svg" />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import store from 'Store/store';

export default {
  name: 'popup',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
  methods: {
    close() {
      store.dispatch('main/hidePopup');
    },
  },
};
</script>

<style scoped>
.popup-root {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
}
.popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  z-index: 9999;
}

.popup-title {
  width: 100%;
  height: 90px;
  text-align: center;
  align-items: center;
  line-height: 90px;
  font-size: 20px;
  font-weight: bold;
  color: #464646;
}

.popup-content {
  width: calc(100% - 30px);
  height: calc(100% - 128px);
  margin: 0px 15px 30px 15px;
  word-wrap: break-word;
  text-align: left;
  white-space: pre-line;
  font-size: 16px;
  color: #000000;
  overflow: scroll;
}

.popup {
  position: fixed;
  margin: 64px 0px 64px 0px;
  background: #ffffff;
  max-width: 80%;
  width: calc(100vw - 40px);
  height: calc(100% - 128px);
  max-height: 80%;
  display: inline-block;
  z-index: 10000;
}

.popup-close {
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px 10px 0px 0px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  /* display: none; */
}

/* .popup-close-mobile {
  cursor: pointer;
  display: block;
  position: fixed;
  bottom: 30px;
  right: 45px;
  width: 24px;
  height: 24px;
} */

@media (min-width: 768px) {
  .popup {
    position: fixed;
    max-width: 60%;
    margin: 0;
  }
  .popup-content {
    margin: 0px 30px 30px 30px;
    width: calc(100% - 60px);
  }
  .popup-mask {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /* .popup-close {
    display: block;
  }
  .popup-close-mobile {
    display: none;
  } */
}
</style>
